function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3840",
  "data-name": "Path 3840",
  d: "M-345.251-308.659h-2.682v-.67a.671.671,0,0,0-.67-.67h0a.671.671,0,0,0-.67.67v.67h-5.363v-.67a.671.671,0,0,0-.67-.67h0a.671.671,0,0,0-.67.67v.67h-2.682A1.34,1.34,0,0,0-360-307.318v13.408a1.34,1.34,0,0,0,1.341,1.341h13.408a1.34,1.34,0,0,0,1.341-1.341v-13.408A1.34,1.34,0,0,0-345.251-308.659Zm0,14.749h-13.408V-303.3h13.408Zm0-10.726h-13.408v-2.682h2.682v.67a.671.671,0,0,0,.67.67h0a.671.671,0,0,0,.67-.67v-.67h5.363v.67a.671.671,0,0,0,.67.67h0a.671.671,0,0,0,.67-.67v-.67h2.682Z",
  transform: "translate(360 310)",
  fill: "#4a4a4a"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.089,
    height: 17.43,
    viewBox: "0 0 16.089 17.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5f8519297760bfcf673f8522d6012412.svg";
export { ForwardRef as ReactComponent };